/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import dynamic from "next/dynamic";
import { Suspense } from "react";

const DynamicNewsSearchEmpty = dynamic(() => import("./NewsSearchEmpty"), {
  ssr: false
});

const DynamicLoadNewsSearchEmpty = (props: any) => {
  return (
    <Suspense>
      <DynamicNewsSearchEmpty {...props} />
    </Suspense>
  )
}

export default DynamicLoadNewsSearchEmpty;
